module.exports = __webpack_public_path__ + "img/imageB.f83e8c56.png";